import { useCallback, useMemo, useReducer } from "react";
import { handleErrorsActions } from "./handle";

// Helpers
import { getErrorKey } from "@/Common/helpers/Modifiers/characters";

function useErrors() {
	// Errors controllers
	const [errors, handleErrors] = useReducer(handleErrorsActions, new Map());

	const hasError = useCallback(
		(key: string) => {
			if (!errors?.size) {
				return false;
			}
			return errors.get(key)?.length || false;
		},
		[errors]
	);

	const hasSomeError = useMemo(() => {
		if (!errors.size) {
			return false;
		}
		return Array.from(errors.values()).some((value) => value?.length);
	}, [errors]);

	// Add an error
	const addError = useCallback((key: string, tabKey = "") => {
		handleErrors({ type: "ADD", key, tabKey });
	}, []);

	// Add a set of errors to the errors list
	const addErrors = useCallback((key: string, localErrors = []) => {
		if (localErrors.length) {
			handleErrors({ key, type: "ADD_LIST_ERRORS", errors: localErrors });
		}
	}, []);

	// Clear all specific key errors
	const clearError = useCallback((key: string) => {
		handleErrors({ type: "CLEAR_LIST_ERRORS", key });
	}, []);

	// Clear all errors
	const clearErrors = useCallback(() => {
		handleErrors({ type: "CLEAR", key: "" });
	}, []);

	// Remove an error from the errors list
	const removeError = useCallback((key: string, tabKey = "") => {
		handleErrors({ type: "REMOVE", key, tabKey });
	}, []);

	// Remove a set of errors from the errors list
	const removeErrors = useCallback((key: string, localErrors = []) => {
		handleErrors({ key, type: "REMOVE_LIST_ERRORS", errors: localErrors });
	}, []);

	return { errors, getErrorKey, hasError, hasSomeError, addError, addErrors, clearError, clearErrors, removeError, removeErrors };
}

export { useErrors };
